module.exports = "/static/media/IAB_logo.c4b833a9.png";